export class SchedulingResourceListDTO {

    id: string;

    title: string;

}
